module.exports = __webpack_public_path__ + "img/icon_feedback_file.97f3a3af.svg";